export default {
  adminlayout: () => import("C:/Users/Administrator/Desktop/lsdope/layouts/adminlayout.vue").then(m => m.default || m),
  default: () => import("C:/Users/Administrator/Desktop/lsdope/layouts/default.vue").then(m => m.default || m),
  sellerlayout: () => import("C:/Users/Administrator/Desktop/lsdope/layouts/sellerlayout.vue").then(m => m.default || m)
}